import { graphql } from '@guuru/graphql-common/gql';

const GET_CHAT = graphql(`
  query GetChatSmsFallback($id: ID!) {
    chat(id: $id) {
      id
      status
      rating
    }
  }
`);

export default GET_CHAT;
